

































import Vue from 'vue'
import PopupThirdQuiz from '@/views/templates/kuntama/PopupThirdQuiz.vue'
import ReshowQuiz from '@/views/atoms/ReshowQuiz'
import ScrollFire from '@/views/mixin/ScrollFire'
import EpisodeTitle from '@/views/templates/kuntama/parts/EpisodeTitle.vue'
import Episode7Item from '@/views/templates/kuntama/parts/Episode7Item.vue'
import OrangeFooterWave from '@/views/templates/kuntama/parts/OrangeFooterWave.vue'

Vue.mixin(ScrollFire)

export default
  components: {
    EpisodeTitle
    Episode7Item
    ReshowQuiz
    PopupThirdQuiz
    OrangeFooterWave
  }

  data: () ->
    fire_scroll: true
    showQuiz: 0
    isSuccess: false
    titles: [
      '燻らのたまご'
      'ラヂウムたまご'
      '燻らの鴨たまご'
    ]
    messages: [
      [
        'こだわりの伝統製法で作られた燻製たまご。'
        '手間暇かけて作られる燻製たまごはまさに絶品！'
      ]
      [
        '源泉100%の飯坂温泉で作られたラヂウムたまご。'
        '白身と黄身が絶妙なバランスで、濃厚な味わい。'
      ]
      [
        '市場にほとんど出回らない、国内産の鴨の燻製たまご。'
        'ニワトリのたまごより一回り大きく、肉厚でジューシーな味わい。'
      ]
    ]
    pictures: [
      '/assets/image/kuntama/episode7_item01.png'
      '/assets/image/kuntama/episode7_item02.png'
      '/assets/image/kuntama/episode7_item03.png'
    ]
    characters: [
      '/assets/image/kuntama/episode7_cara01.png'
      '/assets/image/kuntama/episode7_cara02.png'
      '/assets/image/kuntama/episode7_cara03.png'
    ]

  created: () ->
    @$options.scroll_target = '.episode7'

  methods: {
    closePopup: () ->
      @targetID = -1
    reshow_quiz: () ->
      @showQuiz = 1
    closeQuiz: () ->
      if @isSuccess
        @showQuiz = 3
      else
        @showQuiz = 2
    addPoint: (point) ->
      @$emit('addPoint', point)
    success: () ->
      @isSuccess = true
    scrollFire: () ->
      console.log('episode77')
      if @showQuiz == 0
        @showQuiz = 1
  }
